module.exports = __webpack_public_path__ + "img/glass-laminated.9bc99f7.svg";